module.exports = __webpack_public_path__ + "static/media/republic.d7dc185a.png";